<script>
import FirebaseNodeV3 from '../../base/FirebaseNode'
import CImage from "../../../editor/nodes/CImage.vue";

export default CImage.extend({
  name: "CImageV3",
  mixins: [FirebaseNodeV3],
})
</script>
